import PlaceTypeList from "./PlaceTypeList";
import PlaceTypeCreate from "./PlaceTypeCreate";
import PlaceTypeEdit from "./PlaceTypeEdit";
import PlaceTypeShow from "./PlaceTypeShow";
import PlaceTypeIcon from "@mui/icons-material/LocalBar";

const placeTypes = {
  list: PlaceTypeList,
  create: PlaceTypeCreate,
  edit: PlaceTypeEdit,
  show: PlaceTypeShow,
  icon: PlaceTypeIcon,
};

export default placeTypes;
